module.exports = __webpack_public_path__ + "public/images/logo_pt.8876d4f8074f436c406b0449636dc97c.webp";